import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Procedure History List with Query (for remote operations)
export const getProcedureHistoryListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.URL_GET_PROCEDURE_HISTORY_LIST}?${stringifyParams(
			params
		)}`
	);
};

// Add Procedure History
export const addProcedureHistory = data => {
	return apiClient.post(`${WATER_RIGHTS_BASE}${url.URL_ADD_PROCEDURE_HISTORY}`, data);
};

// Get Procedure History by ID
export const getProcedureHistory = id => {
	return apiClient.get(`${WATER_RIGHTS_BASE}${url.URL_GET_PROCEDURE_HISTORY}${id}`);
};

// Update Procedure History
export const updateProcedureHistory = (id, data) => {
	return apiClient.put(`${WATER_RIGHTS_BASE}${url.URL_UPDATE_PROCEDURE_HISTORY}${id}`, data);
};

// Delete Procedure History
export const deleteProcedureHistory = id => {
	return apiClient.delete(`${WATER_RIGHTS_BASE}${url.URL_DELETE_PROCEDURE_HISTORY}${id}`);
};
